import { render, staticRenderFns } from "./tag-completion.vue?vue&type=template&id=3974bf84"
import script from "./tag-completion.vue?vue&type=script&lang=js"
export * from "./tag-completion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports